import { PaymentProtectedRoute } from './components/PaymentProtectedRoute'
import { PaymentStatusPage } from './pages/PaymentStatus.page'

import type { RouteObject } from 'react-router-dom'

const paymentRoutes: RouteObject[] = [
  {
    path: 'payment-status',
    element: (
      <PaymentProtectedRoute>
        <PaymentStatusPage />
      </PaymentProtectedRoute>
    ),
  },
]

export { paymentRoutes }
